export default __webpack_public_path__ + "static/media/logo.60bc17d8.png";